import React from 'react'
import NavBar from '../NavBar/Navbar'
import { Outlet } from 'react-router-dom'
import Footer from '../Footer/Footer'
import './Layout.css'

export default function Layout() {

  return (
    <>
      <div className='layout-formate'>
        <div className='outlet-main'>
          <NavBar />
          <div className='out_let_conatiner'>
            <Outlet />
          </div>
            <Footer />
        </div>
      </div>
    </>
  )
}
